module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/sjb.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fsjb.png
// module id = i9M/
// module chunks = 93